<template>
  <div class="row">
    <div class="col-md-4">
      <supplier-risk-model-profile-verification-form
        :family-group-id="familyGroupIdDefault"
        :supplier-id="supplierId"
        @onSubmit="submitHandler" />
    </div>
    <div class="col-md-8">
      <div class="row-flex">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <risk-model-result
            :high-config="[60, 100]"
            :medium-config="[40, 59]"
            :low-config="[0, 39]"
            :score="response.score" />
        </div>
      </div>
      <risk-model-result-table
        v-if="response"
        :result="response" />
    </div>
  </div>
</template>

<script>
import
  SupplierRiskModelProfileVerificationForm
  from "@views/admin/RiskModel/Dashboard/RiskModel/SupplierRiskModel/ProfileVerification/SupplierRiskModelProfileVerificationForm";
import RiskModelResultTable from "@views/admin/RiskModel/Dashboard/RiskModel/RiskModelResultTable";
import {RiskModel} from "@/services/ModelRisk/RiskModel";
import RiskModelResult from "@views/admin/RiskModel/Dashboard/RiskModel/Components/RiskModelResult";

export default {
  name: "SupplierRiskModelProfileVerification",
  components: {RiskModelResult, RiskModelResultTable, SupplierRiskModelProfileVerificationForm},
  data: () => ({
    familyGroupIdDefault: 1, // Fotovoltaicos
    response: null
  }),
  props: {
    supplierId: {
      type: Number,
      required: true
    }
  },
  async mounted() {
    this.response = await RiskModel
      .supplier()
      .findProfileVerification(this.supplierId, this.familyGroupIdDefault)

  },
  methods: {
    async submitHandler(ev) {
      this.response = await RiskModel
        .supplier()
        .profileVerification(this.supplierId, this.familyGroupIdDefault, ev)
    }
  }
}
</script>

<style scoped>

</style>
